import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IoMdArrowBack, IoIosCheckmarkCircle } from "react-icons/io";
import toast from "react-hot-toast";
import { changeEmail } from "../../redux/ApiSlice/AccountSettingSlice";

const AccountEmail = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { User_profile } = useSelector((state) => state.AccountProfile);
    const [newEmail, setNewEmail] = useState("");
    const [loading, setLoading] = useState(false);

    return (
        <div className="bg-white dark:bg-[#1E1D21]">
            <div className="sticky top-0 z-50">
                <div className="relative flex items-center justify-center h-12 bg-[#BDE6FF] rounded-b-xl px-2">
                    <IoMdArrowBack
                        onClick={() => navigate("/settings/account/details")}
                        className="absolute left-2 top-1/2 transition-transform -translate-y-1/2 text-[24px] text-black cursor-pointer"
                    />
                    <p className="text-center font-bold text-[16px] text-black flex-grow">Email</p>
                </div>
            </div>

            <form
                onSubmit={async (e) => {
                    e.preventDefault();
                    const trimmedEmail = newEmail.trim();

                    if (!trimmedEmail) {
                        toast.error("Please enter a new email address");
                        return;
                    }
                    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
                        toast.error("Please enter a valid email address");
                        return;
                    }
                    if (trimmedEmail === User_profile?.email) {
                        toast.error("New email cannot be the same as current email");
                        return;
                    }

                    setLoading(true);
                    try {
                        const response = await dispatch(changeEmail({ new_email: trimmedEmail })).unwrap();
                        const message = response?.message || response?.detail || "Verification email sent!";
                        toast.success(message);
                        navigate("/settings/account/verify-email", { state: { newEmail: trimmedEmail } });
                    } catch (error) {
                        const errorMessage =
                            (Array.isArray(error?.new_email) && error.new_email[0]) ||
                            error?.new_email ||
                            error?.detail ||
                            error?.error ||
                            error?.message ||
                            "Failed to send verification email. Please try again.";
                        toast.error(errorMessage);
                    } finally {
                        setLoading(false);
                    }
                }}
                className="px-3 flex flex-col justify-between h-[calc(80vh-60px)]"
            >
                <div className="flex flex-col pt-5">
                    <p className="text-[14px] text-black dark:text-white font-bold">Email</p>
                    <p className="text-[12px] text-justify text-black dark:text-white pt-1">
                        This is the name displayed across Chaa Chingg and how others will recognize you.
                        You can update how your name appears at any time here.
                    </p>

                    <div className="mt-5 border-2 border-[#BDE6FF] dark:border-gray-800/50 rounded-lg">
                        <div className="flex items-center w-full justify-between px-5 py-4 border-b-2 border-[#BDE6FF] dark:border-gray-800/50">
                            <div className="flex flex-col">
                                <p className="text-[12px] text-black dark:text-white font-bold">Verified email address</p>
                                <p className="w-full text-[12px] text-black dark:text-white line-clamp-1">
                                    {User_profile?.email}
                                </p>
                            </div>
                            <IoIosCheckmarkCircle className="text-[22px] text-[#4cb6f9]" />
                        </div>
                        <div className="px-5 py-4">
                            <p className="text-[12px] text-black dark:text-white font-bold">Enter new email address</p>
                            <input
                                type="email"
                                placeholder="Enter new email address"
                                value={newEmail}
                                onChange={(e) => setNewEmail(e.target.value)}
                                className="w-full text-[12px] bg-white dark:bg-[#1E1D21] text-black dark:text-white outline-none mt-1"
                            />
                        </div>
                    </div>
                </div>

                <button 
                    type="submit"
                    disabled={loading || !newEmail.trim()}
                    className={`text-[13px] w-full py-3 rounded-lg font-bold ${
                        loading || !newEmail.trim()
                            ? "bg-[#BDE6FF] text-black cursor-not-allowed"
                            : "bg-[#BDE6FF] text-black cursor-pointer"
                    }`}
                >
                    {loading ? "Sending..." : "Send verification email"}
                </button>
            </form>
        </div>
    )
}

export default AccountEmail